// extracted by mini-css-extract-plugin
export default {"container":"Design_container__GvWJm"};